import { familyHistoryFactory } from 'utils/patientSummaryReport/factory';

export default record => {
  const familyHistory = familyHistoryFactory(record.data || {});
  return `<section class='report-section'>
    <h2 class='section-title'> FHx </h2>
    <p>${familyHistory}</p>
    </section>`;
};
